import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/subscription/details';

export default {

    getSubscriptionDetails(webId) {

        return axios.get(BASE_URL + '/'+ webId );
    }


}
